import Image from '@anm/components/image/Image';
import getCaps from '@anm/data/streaming/destinationsCaps';
import React, { useCallback, useEffect, useState, FC } from 'react';
import { NewDestination } from 'types/stream';

import { DropdownContentWrapper, DropdownItemText, ItemWrapper } from './Wrapper';
import { ListProps } from './types';

type DropdownItemRowWrapperProps = Pick<NewDestination, 'url' | 'onClick' | 'title'>;

const DropdownItemRowWrapper: FC<DropdownItemRowWrapperProps> = ({ url, title, onClick, children }) => {
  const [link, setLink] = useState(url);

  const handleClick = useCallback(() => onClick?.(title), []);

  // TODO should update in tab change
  useEffect(() => {
    const canAddRedirectUrl = url.slice(-1) === '=';

    canAddRedirectUrl && setLink(`${url}${location.href}`);
  }, [url]);

  return onClick ? <div onClick={handleClick}>{children}</div> : <a href={link}>{children}</a>;
};

const DropdownItemRow: FC<NewDestination> = ({ url, title, kind, network, onClick, onSelectDestination }) => (
  <DropdownItemRowWrapper {...{ url, title, onClick }}>
    <ItemWrapper onClick={() => onSelectDestination?.(title)}>
      <Image src={getCaps(network, kind).iconUrl} alt={title} />
      <DropdownItemText>{title}</DropdownItemText>
    </ItemWrapper>
  </DropdownItemRowWrapper>
);

const DropdownContent: FC<ListProps> = ({ list, ...rest }) => (
  <DropdownContentWrapper>
    {list.map(item => (
      <DropdownItemRow key={item.title} {...{ ...item, ...rest }} />
    ))}
  </DropdownContentWrapper>
);

export default DropdownContent;
